import { Link } from 'react-router-dom';
import {
  LayoutGrid, BookCopy, FileStack, SlidersHorizontal, BarChart3, ChevronRight,
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const cards = [
  {
    to: '/dashboard/accounting/coa',
    icon: BookCopy,
    title: 'Bagan akun (COA)',
    desc: 'Daftar kode akun, tambah akun, seed default.',
    accent: 'from-violet-500/10 to-violet-600/5',
    iconBg: 'bg-violet-500',
  },
  {
    to: '/dashboard/accounting/journals',
    icon: FileStack,
    title: 'Jurnal',
    desc: 'Posting manual dan riwayat jurnal terbaru.',
    accent: 'from-emerald-500/10 to-emerald-600/5',
    iconBg: 'bg-emerald-500',
  },
  {
    to: '/dashboard/accounting/settings',
    icon: SlidersHorizontal,
    title: 'Pengaturan',
    desc: 'Otomatis jurnal saat pesanan lunas.',
    accent: 'from-amber-500/10 to-amber-600/5',
    iconBg: 'bg-amber-500',
  },
  {
    to: '/dashboard/accounting/reports/trial-balance',
    icon: BarChart3,
    title: 'Laporan',
    desc: 'Neraca saldo, laba rugi, neraca, arus kas, buku besar, dll.',
    accent: 'from-[#2D6CDF]/15 to-[#2D6CDF]/5',
    iconBg: 'bg-[#2D6CDF]',
  },
];

export default function AccountingOverview() {
  return (
    <div className="space-y-6" data-testid="accounting-overview">
      <p className="text-sm text-slate-600">
        Pilih area kerja di bawah atau gunakan tab di atas. Laporan penjualan (bukan buku besar) ada di{' '}
        <Link className="font-medium text-[#2D6CDF] underline" to="/dashboard/finance-reports">
          Finance Reports
        </Link>
        .
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        {cards.map(({ to, icon: Icon, title, desc, accent, iconBg }) => (
          <Link key={to} to={to} className="group block">
            <Card className={`h-full overflow-hidden border-slate-200/80 bg-gradient-to-br ${accent} transition-all hover:border-[#2D6CDF]/30 hover:shadow-md`}>
              <CardContent className="flex items-start gap-4 p-5">
                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${iconBg} text-white shadow-md`}>
                  <Icon className="h-6 w-6" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-bold text-slate-900 group-hover:text-[#2D6CDF]">{title}</h3>
                    <ChevronRight className="h-5 w-5 shrink-0 text-slate-300 transition-transform group-hover:translate-x-0.5 group-hover:text-[#2D6CDF]" />
                  </div>
                  <p className="mt-1 text-sm text-slate-500">{desc}</p>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
      <Card className="border-dashed border-slate-200 bg-slate-50/50">
        <CardContent className="flex flex-wrap items-center gap-3 p-4 text-sm text-slate-600">
          <LayoutGrid className="h-5 w-5 text-[#2D6CDF]" />
          <span>
            Baru mulai? Buka <strong>Bagan akun</strong> lalu klik <strong>Seed COA</strong> untuk akun default.
          </span>
        </CardContent>
      </Card>
    </div>
  );
}
